import React, { Component } from 'react';


class NavBar extends Component {
    state = {
        isOpen: false
    };
    toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });
    
    render() {
        const menuClass = `dropdown-menu${this.state.isOpen ? " show" : ""}`;
        return (
            <ul className="nav justify-content-center menu">
                <li className="nav-item">
                    <a className="nav-link" href="/#about">A EMPRESA</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href='/containers'>CONTAINERS</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href="/#products">PRODUTOS</a>
                </li>
                <li className={`nav-item dropdown`}>
                    <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" onClick={this.toggleOpen}>ENLACES DE RÁDIOS E PROJETOS ESPECIAIS</a>
                    <div className={`${menuClass} dropdown-menu`}>
                        <a className="dropdown-item" href="/4rf">4RF</a>
                        <a className="dropdown-item" href="/rad">RAD</a>
                    </div>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href={process.env.PUBLIC_URL + `/assets/pdf/garantia-servicos.pdf`} target="_blank">QUALIDADE E GARANTIAS</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href="/#cases">CASOS DE SUCESSO</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href="/#contact">CONTATO</a>
                </li>            
            </ul>
        );
    }
}
 
export default NavBar;